import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CheckoutPaymentCashPage } from 'src/app/modals/checkout-payment-cash/checkout-payment-cash.page';

const routes: Routes = [
  {
    path: '',
    component: CheckoutPaymentCashPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CheckoutPaymentCashPage]
})
export class CheckoutPaymentCashPageModule {}
